export type AuditAssetsDeleteRequestBody = {
  imageIds: Array<string>;
};
